import styles from './index.module.css'

import React, { useState } from 'react';
import { Collapse } from 'antd'
import openVectorImg from '../../../../statics/collect_open_vector.png'
import closeVectorImg from '../../../../statics/collect_close_vector.png'


function FoldingFrame({title, content}) {
    const [activeKeys, setActiveKeys] = useState(['1']); // 默认展开第一个面板

    const handleCollapse = () => {
        // 如果当前有展开的面板，则关闭所有面板，否则展开第一个面板
        if (activeKeys.length > 0) {
            setActiveKeys([])
        } else {
            setActiveKeys(['1'])
        }
    }

    const items = [
        {
            key: '1',
            label: '',
            children: <div>{content}</div>,
            showArrow: false,
        },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.container__header}>
                <div className={styles.container__header_title}>{title}</div>
                <div className={styles.container__header_icon} onClick={handleCollapse}>
                    {
                        activeKeys.length > 0 ? (
                            <img src={closeVectorImg} alt="icon" />
                        ) : (
                            <img src={openVectorImg} alt="icon" />
                        )
                    }
                </div>
            </div>

            <Collapse
                activeKey={activeKeys}
                items={items}
                className={styles.container__collapse}
            />
        </div>
    )
}

export default FoldingFrame